/** @jsxImportSource @emotion/react */

import Button from '@mui/material/Button'
import * as classes from './styles'
import { useImpersonateUser } from './ImpersonateContext'

export const ImpersonateBanner = () => {
  const { impersonateUser, changeImpersonateUser, openWebPage } = useImpersonateUser()

  if (!impersonateUser) {
    return null
  }

  return (
    <div css={classes.wrapper}>
      <div>
        Impersonate feature turned on: {impersonateUser.firstName} {impersonateUser.lastName} ({impersonateUser.email})
      </div>
      <div css={classes.buttons}>
        <Button onClick={openWebPage} size="small" color="blue">
          View
        </Button>
        <Button onClick={() => changeImpersonateUser(null)} size="small" color="red">
          Stop
        </Button>
      </div>
    </div>
  )
}
